import { NgModule } from '@angular/core';
import { MatButtonModule, MatDatepickerModule } from '@angular/material';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FcLocationsInputModule } from '@core/components/fc-input/search-many/fc-locations-input/fc-locations-input.module';
import { CompaniesComponentModule } from '@core/components/inputs/companies/companies.module';
import { EquipmentTypeLegacyModule } from '@core/components/legacy-input/search-one/equipment-type/equipment-type.module';
import { LocationLegacyModule } from '@core/components/legacy-input/search-one/location/location.module';
import { SegmentLegacyModule } from '@core/components/legacy-input/search-one/segment/segment.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { FilterEquipmentsComponent } from './filter-equipments.component';


@NgModule({
  declarations: [
    FilterEquipmentsComponent
  ],
  imports: [
    FuseSharedModule,
    TranslateModule,
    MatDividerModule,
    MatListModule,
    MatSlideToggleModule,
    MatIconModule,
    MatRippleModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatToolbarModule,
    MatSelectModule,
    LocationLegacyModule,
    EquipmentTypeLegacyModule,
    SegmentLegacyModule,
    CompaniesComponentModule,
    FcLocationsInputModule,
    MatDatepickerModule,
    MatButtonModule
  ],
  exports: [
    FilterEquipmentsComponent
  ]
})
export class FilterEquipmentsModule { }
